// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2EImP","boxTitle":"Qualiphy_boxTitle__fHuQk","box":"Qualiphy_box__20IFF","toggleWrap":"Qualiphy_toggleWrap__A8gJB"};